import { getBookIdWithPrefix } from "../utils/content/content";
import { makeRequest } from "./baseApi";
import {parseResponseDefault} from "./not-sorted.utils";

export const getShopBooksRequest = (bookIds = []) => {
  let url = "shop/books?limit=50";
  if (bookIds.length > 0) {
    url += "&" + bookIds.map((item) => "book_id=" + item).join("&");
  }
  return makeRequest({
    url,
    type: "get",
    parseResponse: (response) => {
      if (response.data) {
        const { books, total } = response.data;
        return {
          total,
          books: books.map((item) => ({
            ...item,
            id: getBookIdWithPrefix(item.book_id),
          })),
        };
      }
      return undefined;
    },
  });
};

export const getPackagesRequest = (options) => {
  let limit, offset, packageIds;
  if (options) {
    limit = options.limit;
    offset = options.offset;
    packageIds = options.packageIds;
  }
  const params = [];
  let url = "shop/packages";

  if (packageIds) {
    params.push("package_id=" + packageIds.join("&package_id="));
  }

  if (limit && offset) {
    params.push("limit=" + limit);
    params.push("offset=" + offset);
  }

  if (params.length) {
    url += "?" + params.join("&");
  }

  return makeRequest({
    url,
    type: "get",
    parseResponse: parseResponseDefault,
  });
};

export const createPayPalCheckoutRequest = (data) => {
  const request = {
    url: "paypal/checkout/create",
    type: "post",
    data,
    parseResponse: parseResponseDefault,
  };
  return makeRequest(request);
};
